'use client'

import Link from 'next/link'
import * as React from 'react'

import { AppInfo } from '@/constants/app-info'
import { useLingui } from '@lingui/react'
import Image from 'next/image'
import { ButtonArrow } from '../ui/button-arrow'

import {
  FacebookIcon,
  TelegramIcon,
  TikTokIcon,
  XIcon,
  YouTubeIcon
} from '@/components/ui/brand-icons'
import { msg } from '@lingui/core/macro'

export default function Footer(): React.JSX.Element {
  const SOCIAL_LINKS = [
    {
      name: msg`X (formerly Twitter)`,
      href: 'https://x.com/pione_chain',
      icon: <XIcon className='size-4 shrink-0' />
    },
    {
      name: msg`Facebook`,
      href: 'https://www.facebook.com/pionechain',
      icon: <FacebookIcon className='size-4 shrink-0' />
    },
    {
      name: msg`YouTube`,
      href: 'https://www.youtube.com/@pione_chain',
      icon: <YouTubeIcon className='size-4 shrink-0' />
    },
    {
      name: msg`TikTok`,
      href: 'https://www.tiktok.com/@pione_chain',
      icon: <TikTokIcon className='size-4 shrink-0' />
    },
    {
      name: msg`Telegram`,
      href: 'https://t.me/pionechain',
      icon: <TelegramIcon className='size-4 shrink-0' />
    }
  ]
  const { i18n } = useLingui()
  return (
    <footer className='padding-section relative overflow-hidden bg-[#010C21] pb-14'>
      <div className='relative pb-10 mx-auto max-sm:pt-10 pt-14'>
        <div className='flex flex-col justify-between w-full gap-10 px-5 sm:container lg:flex-row lg:items-start lg:text-left'>
          <div className='mt-10 space-y-4 xl:mt-0 z-10 relative'>
            <div className='flex flex-col items-start w-full gap-5 text-2xl font-bold font-jost md:text-4xl'>
              <p className='flex items-center gap-5'>
                PIONE GLOBAL{' '}
                <svg
                  width='28'
                  height='28'
                  viewBox='0 0 28 28'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M2.90002 0.000939987H26.84C27.16 0.000939987 27.27 0.220933 27.27 0.540933V24.4709C27.27 24.7909 27.16 24.9009 26.84 24.9009H21.55V9.81094L4.09003 27.3809L0 23.2809L17.46 5.82093H2.35999V0.540933C2.35561 0.468878 2.36662 0.396718 2.39221 0.329218C2.4178 0.261717 2.45738 0.200407 2.50842 0.149362C2.55947 0.0983177 2.62079 0.058694 2.68829 0.0331055C2.75579 0.00751702 2.82797 -0.00343932 2.90002 0.000939987Z'
                    fill='#F37021'
                  />
                </svg>
              </p>
              <p className='md:text-nowrap'>{i18n._(`Real - World AI & Blockchain Solutions`)}</p>
            </div>

            <div className='space-y-2.5 mt-20 text-xs sm:text-sm font-light'>
              <p className='text-base font-semibold sm:text-md md:text-xl'>
                {i18n._('PIONE GLOBAL JOINT STOCK COMPANY')}
              </p>
              {i18n.locale === 'vi' && <p className=''>{i18n._(`Tax ID: 0318759430`)}</p>}

              {/* <p className='text-base font-semibold sm:text-md md:text-xl'>
                {i18n._('Pione Global Joint Stock Company')}
              </p> */}
              {/* <p className='text-base text-gray-400'>
                {i18n._(
                  'Operational since February 17, 2014, with nearly 12 years of experience in the Blockchain technology sector.'
                )}
              </p> */}
              {/* <p>{i18n._('Tax ID 0318759141.')}</p> */}
              <p>
                {i18n._('Operating Entity:')}{' '}
                {i18n._(
                  'Euro House, Richmond Hill Road, P.O. Box 2897, Kingstown, Saint Vincent and the Grenadines'
                )}{' '}
              </p>

              {/* <p>
                {i18n._('Representative office:')}{' '}
                {i18n._(
                  'L17-11, 17th floor, Vincom Center Building, 72 Le Thanh Ton Street, Sai Gon Ward, HCMC, Vietnam'
                )}
              </p> */}
              <p>
                {i18n._('Head office:')}{' '}
                {i18n._('RICCO Building - 363 Nguyen Huu Tho Street, Cam Le Ward, Da Nang City, Vietnam')}
              </p>
              {/* <p>
                {i18n._('Head office:')}{' '}
                {i18n._(
                  '213 Tan Thang Street, Tan Son Nhi Ward, HCMC, Vietnam (previously: 213 Tan Thang, Son Ky Ward, Tan Phu District, HCMC, Vietnam).'
                )}
              </p> */}
            </div>
            <div className='relative flex flex-wrap items-center justify-start gap-5 py-3 text-xs sm:text-sm'>
              <Link
                href='mailto:info@pione.asia'
                className='font-medium transition-colors text-nowrap hover:text-orange-400 dark:hover:text-orange-400'
              >
                <span className='font-light '>{i18n._('Email:')}</span> info@pione.asia
              </Link>
              <div className='hidden md:block'>-</div>
              <Link
                href='tel:+842835355888'
                className='font-medium transition-colors text-nowrap hover:text-orange-400 dark:hover:text-orange-400'
              >
                <span className='font-light '>{i18n._('Hotline:')}</span> (+84) 28 3535 5888
              </Link>
              <div className='hidden md:block'>-</div>
              <Link
                href='tel:+84967103466'
                className='font-medium transition-colors text-nowrap hover:text-orange-400 dark:hover:text-orange-400'
              >
                <span className='font-light '>{i18n._('Support:')}</span> (+84) 967 103 466
              </Link>
              <div className='absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-orange-400/70 to-tranfrom-transparent'></div>
              <div className='absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-orange-400/70 to-tranfrom-transparent'></div>
            </div>
          </div>

          <div className='grid w-full grid-cols-2 gap-8 md:grid-cols-4 '>
            <Image
              src='/landing/images/logo-footer.png'
              width={530}
              height={620}
              alt='Background Logo Footer'
              loading='lazy'
              className='w-auto bg-cover absolute top-0 right-[12dvw] z-0'
            />
          </div>
        </div>
        <Image
          src='/landing/images/bg-section-line.png'
          width={1900}
          height={231}
          alt='Background Section Line'
          loading='lazy'
          className='object-contain w-full py-10'
        />
        <div className='px-5 sm:container'>
          <div className='flex flex-col items-center justify-between gap-6 sm:gap-4 sm:flex-row text-[#C0C1C3] text-xs flex-wrap'>
            <p className='text-nowrap'>
              © {new Date().getFullYear()} {AppInfo.APP_NAME}. {i18n._(`All rights reserved.`)}
            </p>
            <div className='flex flex-row items-center gap-4'>
              {SOCIAL_LINKS.map((link) => (
                <Link
                  key={i18n._(link.name)}
                  title={i18n._(link.name)}
                  href={link.href}
                  className='text-[#C0C1C3] bg-white p-2 rounded-full transition-colors'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <span className='sr-only'>{i18n._(link.name)}</span>
                  {link.icon}
                </Link>
              ))}
            </div>
            <div className='flex flex-wrap items-center justify-center gap-4'>
              <Link
                href={'/iot-ai-blockchain'}
                className='transition-colors text-nowrap hover:text-foreground'
              >
                {i18n._(`Services & Solutions`)}
              </Link>
              <Link
                href={'/pione-wallet'}
                className='transition-colors text-nowrap hover:text-foreground'
              >
                {i18n._(`Ecosystem`)}
              </Link>
              <Link
                href={'/news-events'}
                className='transition-colors text-nowrap hover:text-foreground'
              >
                {i18n._(`News & Events`)}
              </Link>
              {/* <Link
                href={'/careers-culture'}
                className='transition-colors text-nowrap hover:text-foreground'
              >
                {i18n._(`Careers & Culture`)}
              </Link> */}
            </div>
            <Link href='/contact'>
              <ButtonArrow showSvg className='relative mt-6'>
                {i18n._(`Contact`)}
              </ButtonArrow>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
